import React from 'react';

const About = () => {
  return (
    <div className="about-page">
      <div className="page-header">
        <div className="container">
          <h1>About Us</h1>
          <p>Learn more about New Jeevan Deep Medical Center</p>
        </div>
      </div>
      <div className="container section">
        <p>About page - To be implemented</p>
      </div>
    </div>
  );
};

export default About;
